import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ConnectedCreatorStoreFront from 'components/CreatorStoreFront';

const CreatorStoreFront = () => <ConnectedCreatorStoreFront />;

export default wrapFunctionalComponent(CreatorStoreFront, 'CreatorStoreFront');
